import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import wind_legend from '../../../assets/images/windLegend.png';
import { useStoreContext } from 'src/store/context';
import {
  AccordionDetails,
  Box,
  Typography,
  Link,
  Modal,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const LegendAccordion = (): React.ReactElement =>{
  const [isClosed, setIsClosed] =useState(false);
  const [state] = useStoreContext();
  const [isDragging, setIsDragging] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const ROW_H = 15;
  const RECT_W = 15;
  const idx = 25;

  const eventControl = (event) => {
    if (event.type === "mousemove" || event.type === "touchmove") {
      setIsDragging(true);
    }
    if (event.type === "mouseup" || event.type === "touchend") {
      setTimeout(() => {
        setIsDragging(false);
      }, 50);
    }
  };

  useEffect(()=>{

  },[state.selectedElement])

  const handleClick = () => {
    setIsClosed(!isClosed);
  }

  const handleInfoClick = () => {
    setIsInfoOpen(true);
  };

  const handleCloseModal = () => {
    setIsInfoOpen(false);
  };

  const getLabel = (label: string, index:number,length:number, value:any)=>{
    if(!label.includes('Precipitation')){
      if(index===length){
        return `${label} when less than or equal to ${value}`;
      }
      else{
        return `${label} when greater than or equal to ${value}`
      } 
    }
    else{
      return `${label} when greater than or equal to ${value}`
    }

  }

	
  return(
  <>
  {
    isClosed?(
      <Draggable bounds={{left:0, right:10000, bottom:0}} onDrag={eventControl} onStop={eventControl}>
        <Accordion defaultExpanded = {true} expanded={true} onClick={() => !isDragging && handleClick()} onTouchEnd={() => !isDragging && handleClick()} style={state.mapDataType ==='FireDanger'? {backgroundColor:'rgba(245, 245, 245,.7)', width:'300px'}: {backgroundColor:'rgba(245, 245, 245,.7)', width:'250px'}}>
          <AccordionSummary
            expandIcon={<ExpandLessIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            style={{height:'60px', minHeight: '50px', paddingTop: '20px'}}
          >
            <div className="font-sans-sm text-bold">LEGEND</div>
          </AccordionSummary>
          {(state.mapDataType ==='Weather' || state.mapDataType ==='FireDanger') &&
            <AccordionDetails className='smooth-scrollbar' style={{overflowY: 'auto', overflowX:'hidden',maxHeight: '75vh',cursor: 'move'}}>
                  {
                    state.mapDataType === 'Weather' &&
                    <svg width="150" height="100">
                      <circle cx="16" cy="20" r="10" fill="white" stroke="#d3d3d3" strokeWidth="2" />
                      <text x="27%" y="18%" textAnchor="start" fill="black" fontSize="15px" dy=".3em">Observation</text>

                      <rect x="0" y="0" transform="translate(16,41) rotate(45)" height="15" width="15" fill="white" stroke="#d3d3d3" strokeWidth="2" />
                      <text x="27%" y="55%" textAnchor="start" fill="black" fontSize="15px" dy=".3em">Forecast</text>

                      <circle cx="16" cy="85" r="10" fill="grey" stroke="red" strokeWidth="2" />
                      <circle cx="10" cy="85" r="2" fill="white" />
                      <circle cx="16" cy="85" r="2" fill="white" />
                      <circle cx="22" cy="85" r="2" fill="white" />
\                      <text x="27%" y="87.5%" textAnchor="start" fill="black" fontSize="14px" dy=".3em">Missing</text>
                      Sorry, your browser does not support inline SVG.
                    </svg>
                  }
                  {
                    state.mapDataType === 'FireDanger' &&
                    <svg width="300" height="170">
                      <circle cx="16" cy="20" r="10" fill="white" stroke="#d3d3d3" strokeWidth="2" />
                      <text x="15%" y="13%" textAnchor="start" fill="black" fontSize="15px" dy=".3em">Observation</text>

                      <rect x="0" y="0" transform="translate(16,41) rotate(45)" height="15" width="15" fill="white" stroke="#d3d3d3" strokeWidth="2" />
                      <text x="15%" y="33%" textAnchor="start" fill="black" fontSize="15px" dy=".3em">Forecast</text>

                      <circle cx="16" cy="85" r="10" fill="grey" stroke="red" strokeWidth="2" />
                      <circle cx="10" cy="85" r="2" fill="white" />
                      <circle cx="16" cy="85" r="2" fill="white" />
                      <circle cx="22" cy="85" r="2" fill="white" />
                      <text x="15%" y="53.5%" textAnchor="start" fill="black" fontSize="14px" dy=".3em">Missing</text>
                      <rect x="2.25%" y="68%" width="18" height="18" fill="white" stroke="red" strokeWidth="2" />
                      <text x="15%" y="74.5%" textAnchor="start" fill="black" fontSize="14px" dy=".3em">Observation NFDRS Quality Flag</text>
                      <svg width='70' height='130' y='40%' x='2.25%'>
                        <polygon points="10 82, 20 100, 0 100" fill='white' stroke='red' strokeWidth='2' />
                      </svg>

                      <text x="15%" y="95.5%" textAnchor="start" fill="black" fontSize="14px" dy=".3em">Forecast NFDRS Quality Flag</text>
                      Sorry, your browser does not support inline SVG.
                    </svg>
                  }

              <div className="font-sans-sm text-bold" style={{width:'100%', paddingBottom:'.5rem'}}>
                {state.mapDataType !=='FireDanger' && state.selectedElement?.legendType}
                {
                  state.mapDataType !=='FireDanger' && state.selectedElement?.unit && 
                  <span className="font-sans-sm text-bold">
                    ({state.selectedElement.unit})
                  </span>
                }
              </div>

              {
                state.selectedElement && !state.selectedElement?.legendType.includes('IC') && !state.selectedElement?.legendType.includes('SC') && !state.selectedElement?.legendType.includes('ERC') && !state.selectedElement?.legendType.includes('BI') &&
                <svg width='200' height={`${((state.selectedElement.colors.length-1) *25)}`}>
                  {
                  state.selectedElement.colors?.map((item:any,index:any)=>(
                    item.value!==null && index!==0 &&
                    <g tabIndex={0} transform={`translate(0, ${idx * (index-1)})`} key={`${item.value}-${index}`} 
                      aria-label={getLabel(state.selectedElement.label, index, state.selectedElement.colors.length, item.value)}>
                      <rect width={RECT_W} height={ROW_H} 
                        style={{ 
                          fill: `rgb(${item.rgb})`, 
                        }} 
                      />
                      <text x={RECT_W + 8} y={ROW_H - 1}>
                        {`${item.value}`}
                      </text>
                    </g>))}
                </svg>
              }
              {
                (state.wind_direction || state.wind_speed) && (state.mapDataType==='Weather') &&
                <div>
                  <span className="font-sans-sm text-bold">Wind Direction and Wind Barbs</span>
                  <img src={wind_legend} alt='Wind Legend' aria-label='Wind legend, the arrow will point to wind direction and the wind barb will determine the speed of the wind' />
                </div>
              }
            </AccordionDetails>
          }
          {state.mapDataType==='FieldSample' && 
          <AccordionDetails
            sx={{
              overflowY: "auto",
              overflowX: "hidden",
              maxHeight: "75vh",
              cursor: "move",
              padding: "16px", 
              width: "300px",
            }}
            className="smooth-scrollbar"
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  border: "2px solid #047857", 
                  backgroundColor: 'white',
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                00
              </Box>
              <Typography
                sx={{
                  marginLeft: "8px",
                  fontSize: "14px",
                }}
              >
                Sample Value
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  border: "2px solid #047857", 
                  backgroundColor: "white", 
                }}
              ></Box>
              <Typography
                sx={{
                  marginLeft: "8px",
                  fontSize: "14px",
                }}
              >
                Value outside date range
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#6B7280", 
                }}
              ></Box>
              <Typography
                sx={{
                  marginLeft: "8px",
                  fontSize: "14px",
                }}
              >
                No Fuel data
              </Typography>
            </Box>
            <Box>
              <Link
                href="#"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#2563EB", 
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleInfoClick();
                }}
              >
                <InfoOutlinedIcon
                  sx={{
                    fontSize: "18px",
                    marginRight: "4px",
                  }}
                />
                Info
              </Link>
            </Box>
          </AccordionDetails>
          }
        </Accordion>
      </Draggable>
    ):(
      <Accordion expanded={false} onClick={handleClick} style={{top:'10%', backgroundColor:'rgba(245, 245, 245)'}}>
        <AccordionSummary
          expandIcon={<ExpandLessIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className="font-sans-sm text-bold">LEGEND</div>
        </AccordionSummary>
      </Accordion>
    )
  }
      <Modal open={isInfoOpen} onClose={handleCloseModal}>
          <Box
            style={{
              backgroundColor: 'white',
              padding: '32px',
              borderRadius: '8px',
              width: '800px',
              margin: '100px auto',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
              position: 'relative',
            }}
          >
          <button
            onClick={handleCloseModal}
            type='button'
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'none',
              border: 'none',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              color: '#6B7280',
            }}
            aria-label="Close"
          >
            ✕
          </button>
          <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>Legend Info</h3>
          <hr style={{ border: 'none', borderTop: '1px solid #E5E7EB', margin: '16px 0' }} />
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  border: '2px solid #047857',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: 'black',
                }}
              >
                00
              </div>
              <span style={{ marginLeft: '8px', fontSize: '14px' , fontWeight: 'bold'}}>Sample Value</span>
            </div>
            <p style={{ fontSize: '14px', color: '#4B5563', paddingRight: '60px' }}>
              Sample Average Value data is calculated for this site and is indicated by the black number
            </p>
          </div>
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  border: '2px solid #047857',
                  backgroundColor: 'white',
                }}
              ></div>
              <span style={{ marginLeft: '8px', fontSize: '14px', fontWeight: 'bold' }}>
                Value outside date range
              </span>
            </div>
            <p style={{ fontSize: '14px', color: '#4B5563' }}>
              Data for this fuel type exists in this site but outside the date range specified
            </p>
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#6B7280',
                }}
              ></div>
              <span style={{ marginLeft: '8px', fontSize: '14px', fontWeight: 'bold' }}>No Fuel data</span>
            </div>
            <p style={{ fontSize: '14px', color: '#4B5563' }}>
                  Data for this fuel type does not exist at this site
            </p>
          </div>
        </Box>
      </Modal>
  </>
  )
}